module.exports = __webpack_public_path__ + "static/media/loading.919557c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Callback/loading.svg
// module id = 1295
// module chunks = 0